var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIconUnselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Home",
    d: "M140.931,187.119h-.69v7.331a4.062,4.062,0,0,1-4.123,4H135.6a1.018,1.018,0,0,1-1.03-1V192.46a2.038,2.038,0,0,0-2.061-2h-1.031a2.038,2.038,0,0,0-2.061,2v4.991a1.019,1.019,0,0,1-1.03,1h-.516a4.062,4.062,0,0,1-4.122-4v-7.331h-.69a1.99,1.99,0,0,1-1.453-3.411l8.934-8.671a2.109,2.109,0,0,1,2.917,0l8.934,8.671a1.993,1.993,0,0,1-1.463,3.411",
    transform: "translate(-121 -174.451)",
    fill: "#293462"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconUnselected);
export default __webpack_public_path__ + "static/media/HomeIconUnselected.cc20957e7473c143495ea317e6cd8ddb.svg";
export { ForwardRef as ReactComponent };